import { get, set } from 'lodash';

import { FIELD_PATHS, INCOME_TYPE } from '@funnels/constants';
import { BusinessIncomeDetails, FormValuesEmployment, Income } from '@funnels/types';

export function removeInValidFullDocIncomes(values: FormValuesEmployment) {
  const incomes: Income[] = get(values, FIELD_PATHS.INCOMES(), []);
  incomes.forEach((income) => {
    const incomeType = get({ incomes: [income] }, FIELD_PATHS.INCOME_TYPE(0));

    // SE full doc
    if (INCOME_TYPE.SELF_EMPLOYED_BUSINESS_INCOME_FULL_DOC === incomeType) {
      const companyIncomes = get({ incomes: [income] }, FIELD_PATHS.INCOME_BUSINESS_INCOMES(0), []);
      const validCompanyIncomes = companyIncomes.filter((companyIncome: BusinessIncomeDetails) => {
        const validatedValues = [];
        const incomeCompanyIncome = { incomes: [{ incomes: [companyIncome] }] };

        const profitBeforeTax = get(
          incomeCompanyIncome,
          FIELD_PATHS.INCOME_BUSINESS_INCOME_COMPANY_PROFIT_BEFORE_TAX(0, 0)
        );
        const depreciation = get(incomeCompanyIncome, FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_DEPRECIATION(0, 0));
        const salary = get(incomeCompanyIncome, FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_SALARY(0, 0));
        const nonRecurringExpenses = get(
          incomeCompanyIncome,
          FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_NON_RECURRING_EXPENSES(0, 0)
        );
        const superannuationExcess = get(
          incomeCompanyIncome,
          FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_SUPERANNUATION_EXCESS(0, 0)
        );
        const lease = get(incomeCompanyIncome, FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_LEASE(0, 0));
        const interest = get(incomeCompanyIncome, FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_INTEREST(0, 0));
        const other = get(incomeCompanyIncome, FIELD_PATHS.INCOME_BUSINESS_INCOME_ADD_BACK_OTHER(0, 0));
        const deduction = get(incomeCompanyIncome, FIELD_PATHS.INCOME_BUSINESS_INCOME_DEDUCTION(0, 0));

        validatedValues.push(profitBeforeTax);
        validatedValues.push(depreciation);
        validatedValues.push(salary);
        validatedValues.push(nonRecurringExpenses);
        validatedValues.push(superannuationExcess);
        validatedValues.push(lease);
        validatedValues.push(interest);
        validatedValues.push(other);
        validatedValues.push(deduction);

        // filter out companyIncome if all category has no value
        return !validatedValues.every((validatedValue) => !isFinite(validatedValue));
      });

      set({ incomes: [income] }, FIELD_PATHS.INCOME_BUSINESS_INCOMES(0), validCompanyIncomes);
    }
  });
}
